// extracted by mini-css-extract-plugin
export default {"createInput":"BoardEditStep_createInput__5BpMH","buttons":"BoardEditStep_buttons__fX7Kk"};